import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import { FormFieldAbstractComponent } from '../form-field-abstract.component';

@Component({
  selector: 'app-form-field-text',
  templateUrl: './form-field-text.component.html',
  styleUrls: ['./form-field-text.component.scss'],
})
export class FormFieldTextComponent
  extends FormFieldAbstractComponent
  implements AfterViewInit
{
  @Input() focused = false;
  @Input() max?: number;
  @Input() min?: number;
  @Input() prefix = '';
  @Input() type = 'text';

  @ViewChild('autoFocusInput')
  autoFocusInputRef!: ElementRef<HTMLInputElement>;

  ngAfterViewInit(): void {
    if (this.focused && this.autoFocusInputRef) {
      setTimeout(() => {
        this.autoFocusInputRef.nativeElement.focus();
      }, 0);
    }
  }

  get showError(): boolean {
    return (
      this.field.touched &&
      !this.field.valid &&
      !this.field.disabled
    );
  }
}
